@if (form) {
  <form class="action-form" [formGroup]="form" (ngSubmit)="onSubmit()">
    <span class="title">{{ 'BANK_IMPORT_TRANSACTIONS.ADD_STARTDATE_BANK_IMPORT' | translate }}</span>
    <div class="row">
      <div class="col-12">
        <app-date-picker
          [form]="form.controls['bankTransactionImportDate']"
          [model]="dataContext.companyBankAccount.bankTransactionsImportStartDate"
          [title]="'BANK_IMPORT_TRANSACTIONS.IMPORT_FROM_DATE'"
        ></app-date-picker>
      </div>
      <div class="col-12">
        <button class="btn btn-active" type="submit">{{ 'SAVE_BTN' | translate }}</button>
        <button class="btn link-btn ml-2" (click)="cancel()">{{ 'CANCEL_BTN' | translate }}</button>
      </div>
    </div>
  </form>
}
